export const FEATURE_KEYS = {
    MEMBERS_SUBSCRIPTIONS: "members_subscriptions",
    PRIVATE_TRAINING: "private_training",
    STOCK_PRODUCTS: "stock_products",
    ACCOUNTING: "accounting",
    ANALYTICS: "analytics",
    MOBILE_APP: "mobile_app",
} as const;

export type FeatureKey = typeof FEATURE_KEYS[keyof typeof FEATURE_KEYS];

export const FEATURE_FALLBACKS: Record<FeatureKey, string[]> = {
    [FEATURE_KEYS.MEMBERS_SUBSCRIPTIONS]: ["members", "memberTypes", "packages", "subscriptions"],
    [FEATURE_KEYS.PRIVATE_TRAINING]: ["coaches", "coachTypes", "sessions", "privateSessions", "coachAvailability"],
    [FEATURE_KEYS.STOCK_PRODUCTS]: ["products", "checkout"],
    [FEATURE_KEYS.ACCOUNTING]: ["income", "incomeTypes", "expenses", "expenseTypes"],
    [FEATURE_KEYS.ANALYTICS]: ["reports", "history"],
    [FEATURE_KEYS.MOBILE_APP]: ["mobileApp", "mobileAuth", "classBookings"],
};
